<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i class="material-icons" id="menu-toggle" @click="isSidebar =  !isSidebar">view_headline</i>
        <app-navbar></app-navbar>

        <div class="container mt-5">
          <div class="col-sm-12">
            <vs-breadcrumb
              align="left"
              :items="
                  [
                    {title: 'You are here : '},
                    {
                      title: 'Dashboard',
                      url: '/#/dashboard/Trainer/trainerDashboard',
                    },
                    {
                      title: 'Trainings',
                      url: '/#/dashboard/Trainer/Trainings',
                       active: true
                    }
                  ]"
            ></vs-breadcrumb>
            <div class="frm-title">
              <div class="heading mt-3">
                <h3 class="text-secondary">Trainings</h3>
              </div>
            </div>

            <div class="row">
              <div
                v-for="(training,index) in trainings"
                v-bind:key="index"
                class="col-sm-6 col-md-4"
              >
                <div class="kb-box h-100">
                  <div class="title-header">
                    <router-link
                      :to="{ path: '/dashboard/Trainer/knowledgeBaseRepDetail', query: { training: training.training_code }}"
                    >
                      <!-- <router-link to="/dashboard/Trainer/knowledgeBaseRepDetail"> -->
                      <h6 class="text-secondary">{{training.title}}</h6>
                    </router-link>
                  </div>
                  <div class="body-box">
                    <span class="text-secondary">
                      <b>Subprogram:</b>
                      {{training.subprogram.title}}
                    </span>
                  </div>
                  <!-- <div class="clear-fix"></div> -->
                  <div class="footer">
                    <span class="text-secondary mt-3">
                      <b>Start Date:</b>
                      {{training.startdate}}
                    </span>
                    <span class="float-right text-secondary">
                      <b>End Date:</b>
                      {{training.enddate}}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
// import Sidebar from "./Sidebar";

import "bootstrap/dist/css/bootstrap.css";

// Import date picker css
import "pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css";
import axios from "axios";
export default {
  data: () => ({
    isSidebar: false,
    trainings: []
  }),
  components: {
    "app-navbar": Navbar
    // "app-sidebar": Sidebar
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    // Set the initial number of items
    // this.totalRows = this.items.length;
    this.openLoading();
    axios
      .get(
        process.env.VUE_APP_BASE_PATH +
          "/get/all/training/" +
          JSON.parse(localStorage.getItem("currentUser")).id +
          ""
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.trainings = response.data;
      });
  },
  methods: {
    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
      this.$vs.loading.close();
    },
    showForm() {
      this.isForm = false;
      this.isFormData = true;
    },
    successUpload() {
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Files have been Uploaded, consectetur"
      });
    }
    // togglemenu() {
    //   $("#wrapper").toggleClass("toggled");
    // }
  }
};
</script>
<style>
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.vs-avatar--text {
  text-transform: uppercase !important;
}
/* .vs-card--header {
 background: #cccccc7a;
} */
.vs-card--content {
  margin-bottom: 0px !important;
}

.kb-box {
  width: 100%;
  height: auto;
  background: #fff;
  /* border-radius: 8px; */
  /* margin-bottom: 20px; */
  display: block;
  -webkit-box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  /* padding:5px; */
}
.title-header {
  /* border-radius: 8px; */
  /* margin-bottom: 10px; */
  display: block;
  /* -webkit-box-shadow: 0 4px 25px 0 rgba(0,0,0,.1);
  box-shadow: 0 4px 25px 0 rgba(0,0,0,.1);
  -webkit-transition: all .3s ease;
  transition: all .3s ease; */
  background: #cccccc7a;
  padding: 5px;
  border-left: 3px solid #06a6e0;
}
.body-box {
  padding: 15px 5px;
}
.footer {
  padding: 15px 5px;
}

.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}

@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}
</style>


